import * as React from "react";

export class HeadingTypeOne extends React.Component<{
    modifier?: string;
}, {}> {
    class: string;
    constructor(props) {
        super(props);
        const { modifier } = this.props;
        const baseClass = "rj-heading-1";

        this.class = baseClass +
            (modifier ? ` ${baseClass}--${modifier}` : "");
    }

    render() {
        return (
            <h3 className={this.class}>
                {this.props.children}
            </h3>
        )
    }
}